// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Close: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path
                fill="currentColor"
                d="M21.6557884,20.2123488 C22.0657241,20.6211763 22.0657241,21.2844916 21.6557884,21.693363 C21.2458528,22.1022343 20.5807393,22.1021904 20.1707596,21.693363 L15.0007244,16.4989045 L9.79393548,21.6916171 C9.38399916,22.1004446 8.71888639,22.1004446 8.30890668,21.6916171 C7.89892696,21.2827897 7.89897035,20.6194744 8.30890668,20.210603 L13.5174455,15.0196362 L8.30746257,9.78765116 C7.89752625,9.37882375 7.89752625,8.71550841 8.30746257,8.30663704 C8.71739889,7.89776568 9.38251165,7.89780963 9.79249137,8.30663704 L15.0007244,13.5403679 L20.2075133,8.34765522 C20.6174489,7.9388278 21.2825623,7.9388278 21.6925421,8.34765522 C22.1025218,8.75648263 22.1024777,9.41979797 21.6925421,9.82866934 L16.4840026,15.0196362 L21.6557884,20.2123488 Z"
                transform="translate(-8 -8)"
            />
        </svg>
    );
};

export default React.memo(Close);
